document.addEventListener('DOMContentLoaded', function () {
  const realResultsSlider = document.querySelector('.Product_real_results_slider');

  if (realResultsSlider) {
    new Swiper(realResultsSlider, {
      slidesPerView: 1.2,
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: false,
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        750: {
          // slidesPerView: 2.2,
          spaceBetween: 16
        },
        990: {
          // slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });
  }

  const popupContainer = document.querySelector('.Product_real_results_slide_video_popup_container');
  if (!popupContainer) return;

  const triggers = document.querySelectorAll('.Product_real_results_video_trigger');
  const popups = popupContainer.querySelectorAll('.Product_real_results_slide_video_popup');
  const closeButtons = popupContainer.querySelectorAll('.Product_real_results_slide_video_popup_close');

  function closeAllPopups() {
    popupContainer.classList.remove('is-open');

    popups.forEach((popup) => {
      popup.classList.remove('is-open');

      popup.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });
    });

    document.body.classList.remove('overflow-hidden');
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const triggerId = this.dataset.videoTrigger;

      popupContainer.classList.add('is-open');
      document.body.classList.add('overflow-hidden');

      popups.forEach((popup) => {
        const popupId = popup.dataset.videoPopup;

        if (popupId === triggerId) {
          popup.classList.add('is-open');

          popup.querySelectorAll('video').forEach((video) => {
            if (video.dataset.src && !video.getAttribute('src')) {
              video.setAttribute('src', video.dataset.src);
              video.load();
            }

            video.play().catch(() => {});
          });
        } else {
          popup.classList.remove('is-open');

          popup.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.currentTime = 0;
          });
        }
      });
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllPopups();
    });
  });

  popupContainer.addEventListener('click', function (e) {
    const clickedPopup = e.target.closest('.Product_real_results_slide_video_popup');
    const clickedVideo = e.target.closest('video');

    if (!clickedPopup || !clickedVideo) {
      closeAllPopups();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popupContainer.classList.contains('is-open')) {
      closeAllPopups();
    }
  });
});